$( document ).ready(function() {
    console.log( "ready Vi !" );

// =================================================
// Plyr for Banner Slidr :: Init
// =================================================
    let getHomeBannerVideo = $('#vi_emeslider_vidplyr');
    const ghHomePlyr = new Plyr( getHomeBannerVideo, {
        controls : false,
        autoplay : true,
        playsinline : true,
        muted : true, 
        hideControls : true,
        // resetOnEnd : true,
        // loop : true, 
    });

// =================================================
// Home Banner Slider
// =================================================

    let getHomeBannerSlider = $("#vi_emeslider_main_v2.video__disabled");
    if( getHomeBannerSlider.length ){
        let argsSliderESV2 = { 
            items: 1,
            loop: true, 
            // margin: 0,
            autoplay: true,
            dots: true,
            autoplayHoverPause: true,
            //animateOut: "fadeOut", 
            // dragEndSpeed: 1500,
            navSpeed: 1000,
            // smartSpeed: 500,
            nav : false,
            animateIn: 'fadeIn',
            animateOut: 'fadeOut',
            // navText: ['<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-left"></use></svg>', '<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-right"></use></svg>'],
            // lazyLoad: true,
            responsive: {
                768: {
                    items: 1,
                },
                1200: {
                    items: 1,
                }
            }
        }
        getHomeBannerSlider.owlCarousel(argsSliderESV2);
    }

// =================================
// Footer Awards Slider
// =================================
    let ftAwards = $("#tkdh_ft_awards");
    if( ftAwards.length ){
        let argsFtAwards = { 
            items: 3,
            loop: false, 
            margin: 30,
            autoplay: false,
            dots: false,
            autoplayHoverPause: false,
            rewindNav:true,
            //animateOut: "fadeOut", 
            // dragEndSpeed: 1500,
            navSpeed: 800,
            smartSpeed: 800,
            slideTransition: 'linear',
            nav : false,
            animateIn: 'fadeIn',
            animateOut: 'fadeOut',
            // navText: ['<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-left"></use></svg>', '<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-right"></use></svg>'],
            lazyLoad: true,
            responsive: {
                768: {
                    items: 3,
                    margin: 0,
                },
                1200: {
                    items: 3,
                    margin: 0,
                }
            }
        }
        ftAwards.owlCarousel(argsFtAwards);
    }



// ======================================
// Homepage Offers Slider + Counter
// ======================================

    let hmpgOffers = $(".imgin__txtcont_countr_slidr_main");

    if( hmpgOffers.length ){
            
        hmpgOffers.on("initialized.owl.carousel changed.owl.carousel", function(e) {
            
            if (!e.namespace) {
                return;
            }
            
            let expCounter, curItemCounter, totalItemCounter;
            
            // -- Add trailing zeroes to both CurrentItemCount and TotalCount when the total count is less than 10
            if( e.item.count < 9 ){
                expCounter = (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+(e.item.count)+"</span>"
            }
            // -- When total count is more than 10
            else{
                // -- if CurrentItemCount is less than 10, add leading zero
                if(e.item.index < 9 ){
                    curItemCounter = (e.relatedTarget.relative(e.item.index) + 1);
                    // totalItemCounter = "<span>"+ "0" + (e.item.count) +"</span>";
                    totalItemCounter = "<span>"+ e.item.count +"</span>"
                }
                else{
                    curItemCounter = e.relatedTarget.relative(e.item.index) + 1; 
                    totalItemCounter = "<span>"+ e.item.count +"</span>"
                }
                expCounter = curItemCounter + " | " + totalItemCounter
            }
            
            // -- When TotalCount is exactly 10, 
            if( e.item.count === 10 ){
                
                if(e.item.index === 9 ){
                    expCounter = e.relatedTarget.relative(e.item.index) + 1 + " | " + "<span>"+ e.item.count +"</span>"
                }
                else{
                    expCounter = (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+ e.item.count +"</span>"
                }
            }
            
            // -- If TotalCount is exactly 9,
            if( e.item.count === 9 ){
                expCounter = (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+ (e.item.count) +"</span>"
            }
            
            // Add counter to the HTML
            $(".explore-counter").html( expCounter );
            
        })
        
        .owlCarousel({
            items: 1,
            loop: true, 
            margin: 0,
            autoplay: false,
            dots: false,
            autoplayHoverPause: true, 
            // dragEndSpeed: 1500,
            navSpeed: 800,
            smartSpeed: 800,
            slideTransition: 'linear',
            nav : false,
            animateIn: 'fadeIn',
            animateOut: 'fadeOut',
            navText: ['<svg width="12" height="25" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tkdh__slidr_nav_left_arrow"></use></svg>', '<svg width="12" height="25" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tkdh__slidr_nav_rght_arrow"></use></svg>'],
            lazyLoad: true,
            responsive: {
                768: {
                    items: 1,
                },
                1600: {
                    items: 1,
                }
            }
        });
        
        
        // custom nav buttons with the counter
        $('.imgin__txtcont_countr_slidr_main_item_cont_btm_cta_nav_rght a').click(function(){
            // console.log("next");
            hmpgOffers.trigger('next.owl.carousel');
        });
        
        $('.imgin__txtcont_countr_slidr_main_item_cont_btm_cta_nav_left a').click(function(){
            // console.log("prev");
            hmpgOffers.trigger('prev.owl.carousel');
        });
        
    }


// =================================================
// Inline Videos :: Homepage Bar Section
// =================================================
    let getHmpg_Bar_video = $('#comp__inline_video_plyr');

    if(getHmpg_Bar_video.length){
        const hmpg_bar_vid = new Plyr( getHmpg_Bar_video, {
            controls : true,
            playsinline : true,
            controls : ['play-large', 'play', 'progress', 'mute',  ],
        });
    
        hmpg_bar_vid.toggleControls(false);
    
        hmpg_bar_vid.on('play', event => {
            hmpg_bar_vid.toggleControls(true);
        });
    }


// =============================================
// Homepage Testimonials Slider + Counter
// =============================================

    let hmpgTestimonialsSlidr = $(".tdkh__pg_home_testimonials_slidr");
    if( hmpgTestimonialsSlidr.length ){
            
        hmpgTestimonialsSlidr.on("initialized.owl.carousel changed.owl.carousel", function(e) {
            // console.log(e.item.count);
            if (!e.namespace) {
                return;
            }
            
            let expCounterTS, curItemCounterTS, totalItemCounterTS;
            
            // -- Add trailing zeroes to both CurrentItemCount and TotalCount when the total count is less than 10
            if( e.item.count < 9 ){
                expCounterTS = (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+(e.item.count)+"</span>"
            }
            // -- When total count is more than 10
            else{
                // -- if CurrentItemCount is less than 10, add leading zero
                if(e.item.index < 9 ){
                    curItemCounterTS = (e.relatedTarget.relative(e.item.index) + 1);
                    // totalItemCounterTS = "<span>"+ "0" + (e.item.count) +"</span>";
                    totalItemCounter = "<span>"+ e.item.count +"</span>"
                }
                else{
                    curItemCounterTS = e.relatedTarget.relative(e.item.index) + 1; 
                    totalItemCounterTS = "<span>"+ e.item.count +"</span>"
                }
                expCounterTS = curItemCounterTS + " | " + totalItemCounterTS
            }
            
            // -- When TotalCount is exactly 10, 
            if( e.item.count === 10 ){
                
                if(e.item.index === 9 ){
                    expCounterTS = e.relatedTarget.relative(e.item.index) + 1 + " | " + "<span>"+ e.item.count +"</span>"
                }
                else{
                    expCounterTS = (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+ e.item.count +"</span>"
                }
            }
            
            // -- If TotalCount is exactly 9,
            if( e.item.count === 9 ){
                expCounterTS = (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+ (e.item.count) +"</span>"
            }
            
            // Add counter to the HTML
            $(".explore-counterz").html( expCounterTS );
            
        })
        
        .owlCarousel({
            items: 1,
            loop: false, 
            margin: 20,
            autoplay: false,
            dots: false,
            autoplayHoverPause: true, 
            // dragEndSpeed: 1500,
            navSpeed: 800,
            smartSpeed: 800,
            slideTransition: 'linear',
            nav : false,
            animateIn: 'fadeIn',
            animateOut: 'fadeOut',
            navText: ['<svg width="12" height="25" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tkdh__slidr_nav_left_arrow"></use></svg>', '<svg width="12" height="25" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tkdh__slidr_nav_rght_arrow"></use></svg>'],
            lazyLoad: true,
            responsive: {
                768: {
                    items: 1,
                },
                1600: {
                    items: 1,
                }
            }
        });
        
        
        // custom nav buttons with the counter
        $('.tdkh__pg_home_testimonials_slidr_item_nav_rght a').click(function(){
            // console.log("next");
            hmpgTestimonialsSlidr.trigger('next.owl.carousel');
        });
        
        $('.tdkh__pg_home_testimonials_slidr_item_nav_left a').click(function(){
            // console.log("prev");
            hmpgTestimonialsSlidr.trigger('prev.owl.carousel');
        });
        
    }



// =========================================================================================
// Slider with nav arrows and text labels (dots) + Counter :: Used Homepage Facilities
// =========================================================================================
    let slidrLabelDots = $(".comp__slidr_labeldots");
    if( slidrLabelDots.length ){
            
        slidrLabelDots.on("initialized.owl.carousel changed.owl.carousel", function(e) {
            // console.log(e.item.count);
            if (!e.namespace) {
                return;
            }
            
            let expCounterLD, curItemCounterLD, totalItemCounterLD;
            
            // -- Add trailing zeroes to both CurrentItemCount and TotalCount when the total count is less than 10
            if( e.item.count < 9 ){
                expCounterLD = (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+(e.item.count)+"</span>"
            }
            // -- When total count is more than 10
            else{
                // -- if CurrentItemCount is less than 10, add leading zero
                if(e.item.index < 9 ){
                    curItemCounterLD = (e.relatedTarget.relative(e.item.index) + 1);
                    // totalItemCounterLD = "<span>"+ "0" + (e.item.count) +"</span>";
                    totalItemCounter = "<span>"+ e.item.count +"</span>"
                }
                else{
                    curItemCounterLD = e.relatedTarget.relative(e.item.index) + 1; 
                    totalItemCounterLD = "<span>"+ e.item.count +"</span>"
                }
                expCounterLD = curItemCounterLD + " | " + totalItemCounterLD
            }
            
            // -- When TotalCount is exactly 10, 
            if( e.item.count === 10 ){
                
                if(e.item.index === 9 ){
                    expCounterLD = e.relatedTarget.relative(e.item.index) + 1 + " | " + "<span>"+ e.item.count +"</span>"
                }
                else{
                    expCounterLD = (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+ e.item.count +"</span>"
                }
            }
            
            // -- If TotalCount is exactly 9,
            if( e.item.count === 9 ){
                expCounterLD = (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+ (e.item.count) +"</span>"
            }
            
            // Add counter to the HTML
            $(".explore-counter-ld").html( expCounterLD );
            
        })
        
        .owlCarousel({
            items: 1,
            loop: false, 
            margin: 0,
            autoplay: false,
            dots: true,
            dotData: true,
            dotsData: true,
            // autoplayHoverPause: true, 
            // dragEndSpeed: 1500,
            navSpeed: 800,
            smartSpeed: 800,
            slideTransition: 'linear',
            nav : false,
            animateIn: 'fadeIn',
            animateOut: 'fadeOut',
            navText: ['<svg width="12" height="25" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tkdh__slidr_nav_left_arrow"></use></svg>', '<svg width="12" height="25" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tkdh__slidr_nav_rght_arrow"></use></svg>'],
            lazyLoad: true,
            responsive: {
                768: {
                    items: 1,
                    dots: true,
                    dotData: true,
                    dotsData: true,
                },
                1600: {
                    items: 1,
                    dots: true,
                    dotData: true,
                    dotsData: true,
                }
            }
        });
        
        
        // custom nav buttons with the counter
        $('.comp__slidr_labeldots .comp__slidr_labeldots_item_nav_rght a').click(function(){
            // console.log("next");
            slidrLabelDots.trigger('next.owl.carousel');
        });
        
        $('.comp__slidr_labeldots .comp__slidr_labeldots_item_nav_left a').click(function(){
            // console.log("prev");
            slidrLabelDots.trigger('prev.owl.carousel');
        });
        
    }


// ======================================================================================
// Homepage Accomodation Slider with nav arrows and text labels (dots) + Counter
// ======================================================================================
    let slidrLabelDots_hmpgAccom = $("#tdkh__pg_home_accom .tdkh__pg_home_accom_comp__slidr_labeldots");
    if( slidrLabelDots_hmpgAccom.length ){
            
        slidrLabelDots_hmpgAccom.on("initialized.owl.carousel changed.owl.carousel", function(e) {
            // console.log(e.item.count);
            if (!e.namespace) {
                return;
            }
            
            let expCounterLD, curItemCounterLD, totalItemCounterLD;
            
            // -- Add trailing zeroes to both CurrentItemCount and TotalCount when the total count is less than 10
            if( e.item.count < 9 ){
                expCounterLD = (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+(e.item.count)+"</span>"
            }
            // -- When total count is more than 10
            else{
                // -- if CurrentItemCount is less than 10, add leading zero
                if(e.item.index < 9 ){
                    curItemCounterLD = (e.relatedTarget.relative(e.item.index) + 1);
                    // totalItemCounterLD = "<span>"+ "0" + (e.item.count) +"</span>";
                    totalItemCounter = "<span>"+ e.item.count +"</span>"
                }
                else{
                    curItemCounterLD = e.relatedTarget.relative(e.item.index) + 1; 
                    totalItemCounterLD = "<span>"+ e.item.count +"</span>"
                }
                expCounterLD = curItemCounterLD + " | " + totalItemCounterLD
            }
            
            // -- When TotalCount is exactly 10, 
            if( e.item.count === 10 ){
                
                if(e.item.index === 9 ){
                    expCounterLD = e.relatedTarget.relative(e.item.index) + 1 + " | " + "<span>"+ e.item.count +"</span>"
                }
                else{
                    expCounterLD = (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+ e.item.count +"</span>"
                }
            }
            
            // -- If TotalCount is exactly 9,
            if( e.item.count === 9 ){
                expCounterLD = (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+ (e.item.count) +"</span>"
            }
            
            // Add counter to the HTML
            $(".explore-counter-hmpgaccom").html( expCounterLD );
            
        })
        
        .owlCarousel({
            items: 1,
            loop: true, 
            margin: 0,
            autoplay: false,
            dots: false,
            dotData: false,
            dotsData: false,
            // autoplayHoverPause: true, 
            // dragEndSpeed: 1500,
            navSpeed: 800,
            smartSpeed: 800,
            slideTransition: 'linear',
            nav : false,
            animateIn: 'fadeIn',
            animateOut: 'fadeOut',
            navText: ['<svg width="12" height="25" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tkdh__slidr_nav_left_arrow"></use></svg>', '<svg width="12" height="25" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tkdh__slidr_nav_rght_arrow"></use></svg>'],
            lazyLoad: true,
            responsive: {
                768: {
                    items: 1,
                    dots: true,
                    dotData: true,
                    dotsData: true,
                },
                1600: {
                    items: 1,
                    dots: true,
                    dotData: true,
                    dotsData: true,
                }
            }
        });
        
        
        // custom nav buttons with the counter
        $('.tdkh__pg_home_accom_comp__slidr_labeldots_item_nav_rght a').click(function(){
            // console.log("next");
            slidrLabelDots_hmpgAccom.trigger('next.owl.carousel');
        });
        
        $('.tdkh__pg_home_accom_comp__slidr_labeldots_item_nav_left a').click(function(){
            // console.log("prev");
            slidrLabelDots_hmpgAccom.trigger('prev.owl.carousel');
        });
        
    }

// =============================================================================
// Homepage Accomodation Slider :: Hide selected data dot navigation label
// =============================================================================
    let dataDotItemtoHide = $("button.hide_datadot_label");
    if(dataDotItemtoHide.length){
        dataDotItemtoHide.parent().hide();
    }

// =================================================
// Homepage Gallery with Tabs
// =================================================

    $(".gallery-nav li").each(function(i) {
        $(this).click(function() {
            $("#tabwrapper").find(".tabgal:eq('" + i + "')").show().siblings().hide();

            // $("#left-navbar").show();
            

            $("#gallery-toggle").removeClass("open");
            $(".gallery-nav li").removeClass("active");
            $(this).addClass("active");
                
            $( "#addtitle" ).empty();
            $( "#addtitle" ).append($(this).text());
            // console.log(gettext);
        });
    });


// =================================================
// Items Masonry Grid :: Used MasonryJS
// =================================================
    let masonryItemsGrid = $(".comp__items_msonry_grid");
    if(masonryItemsGrid.length){
        masonryItemsGrid.masonry({
            // options
            itemSelector: '.comp__items_msonry_grid_item',
            columnWidth: '.comp__items_msonry_grid_item',
            percentPosition: true,
            gutter: 10,
            transitionDuration: '0.7s',
            stagger: 40,
        });
    };

// ===================================================
// Innerpages You may also like section + Counter
// ===================================================
    let ymalSlidr = $(".comp__pginrs_ymal_cont_slidr");
    if( ymalSlidr.length ){
                
        ymalSlidr.on("initialized.owl.carousel changed.owl.carousel", function(e) {
            // console.log(e.item.count);
            if (!e.namespace) {
                return;
            }
            
            let expCounterYMAL, curItemCounterYMAL, totalItemCounterYMAL;
            
            // -- Add trailing zeroes to both CurrentItemCount and TotalCount when the total count is less than 10
            if( e.item.count < 9 ){
                expCounterYMAL = (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+(e.item.count)+"</span>"
            }
            // -- When total count is more than 10
            else{
                // -- if CurrentItemCount is less than 10, add leading zero
                if(e.item.index < 9 ){
                    curItemCounterYMAL = (e.relatedTarget.relative(e.item.index) + 1);
                    // totalItemCounterYMAL = "<span>"+ "0" + (e.item.count) +"</span>";
                    totalItemCounterYMAL = "<span>"+ e.item.count +"</span>"
                }
                else{
                    curItemCounterYMAL = e.relatedTarget.relative(e.item.index) + 1; 
                    totalItemCounterYMAL = "<span>"+ e.item.count +"</span>"
                }
                expCounterYMAL = curItemCounterYMAL + " | " + totalItemCounterYMAL
            }
            
            // -- When TotalCount is exactly 10, 
            if( e.item.count === 10 ){
                
                if(e.item.index === 9 ){
                    expCounterYMAL = e.relatedTarget.relative(e.item.index) + 1 + " | " + "<span>"+ e.item.count +"</span>"
                }
                else{
                    expCounterYMAL = (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+ e.item.count +"</span>"
                }
            }
            
            // -- If TotalCount is exactly 9,
            if( e.item.count === 9 ){
                expCounterYMAL = (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+ (e.item.count) +"</span>"
            }
            
            // Add counter to the HTML
            $(".explore-counter-ymal").html( expCounterYMAL );


            
            
            
            // Implement disable nav on first and last slides

            ymalSlidr.find(".comp__pginrs_ymal_cont_slidr_item_count").removeClass( "yaml_slidr_first" );
            ymalSlidr.find(".comp__pginrs_ymal_cont_slidr_item_count").removeClass( "yaml_slidr_last" );
            
            let ymalSlidr_getCurrentSlidr = e.item.index + 1;
            let ymalSlidr_getTotalSlidr = e.item.count;
            let ymalSlidr_placement;

            if(ymalSlidr_getCurrentSlidr === 1){
                ymalSlidr_placement = "yaml_slidr_first";
            }
            if (ymalSlidr_getCurrentSlidr === ymalSlidr_getTotalSlidr) {
                ymalSlidr_placement = "yaml_slidr_last";
            }
            ymalSlidr.find(".comp__pginrs_ymal_cont_slidr_item_count").addClass( ymalSlidr_placement );
            
        })
        
        .owlCarousel({
            items: 1,
            loop: false, 
            margin: 0,
            autoplay: false,
            dots: false,
            autoplayHoverPause: true, 
            // dragEndSpeed: 1500,
            navSpeed: 800,
            smartSpeed: 800,
            slideTransition: 'linear',
            nav : false,
            animateIn: 'fadeIn',
            animateOut: 'fadeOut',
            navText: ['<svg width="12" height="25" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tkdh__slidr_nav_left_arrow"></use></svg>', '<svg width="12" height="25" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tkdh__slidr_nav_rght_arrow"></use></svg>'],
            lazyLoad: true,
            responsive: {
                768: {
                    items: 1,
                },
                1600: {
                    items: 1,
                }
            }
        });
        
        
        // custom nav buttons with the counter
        $('.comp__pginrs_ymal_cont_slidr_item_count_rght a').click(function(){
            // console.log("next");
            ymalSlidr.trigger('next.owl.carousel');
        });
        
        $('.comp__pginrs_ymal_cont_slidr_item_count_left a').click(function(){
            // console.log("prev");
            ymalSlidr.trigger('prev.owl.carousel');
        });
        
    }



// ===================================================
// Fullwidth Slider + Counter
// ===================================================
    let fwSlidrwCountr = $(".comp__fwslidr_wcountr");
    if( fwSlidrwCountr.length ){
                
        fwSlidrwCountr.on("initialized.owl.carousel changed.owl.carousel", function(e) {
            // console.log(e.item.count);
            if (!e.namespace) {
                return;
            }
            
            let expCounterYMAL, curItemCounterYMAL, totalItemCounterYMAL;
            
            // -- Add trailing zeroes to both CurrentItemCount and TotalCount when the total count is less than 10
            if( e.item.count < 9 ){
                expCounterYMAL = (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+(e.item.count)+"</span>"
            }
            // -- When total count is more than 10
            else{
                // -- if CurrentItemCount is less than 10, add leading zero
                if(e.item.index < 9 ){
                    curItemCounterYMAL = (e.relatedTarget.relative(e.item.index) + 1);
                    // totalItemCounterYMAL = "<span>"+ "0" + (e.item.count) +"</span>";
                    totalItemCounterYMAL = "<span>"+ e.item.count +"</span>"
                }
                else{
                    curItemCounterYMAL = e.relatedTarget.relative(e.item.index) + 1; 
                    totalItemCounterYMAL = "<span>"+ e.item.count +"</span>"
                }
                expCounterYMAL = curItemCounterYMAL + " | " + totalItemCounterYMAL
            }
            
            // -- When TotalCount is exactly 10, 
            if( e.item.count === 10 ){
                
                if(e.item.index === 9 ){
                    expCounterYMAL = e.relatedTarget.relative(e.item.index) + 1 + " | " + "<span>"+ e.item.count +"</span>"
                }
                else{
                    expCounterYMAL = (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+ e.item.count +"</span>"
                }
            }
            
            // -- If TotalCount is exactly 9,
            if( e.item.count === 9 ){
                expCounterYMAL = (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+ (e.item.count) +"</span>"
            }
            
            // Add counter to the HTML
            $(".explore-counter-fwslidr").html( expCounterYMAL );
            
        })
        
        .owlCarousel({
            items: 1,
            loop: true, 
            margin: 0,
            autoplay: false,
            dots: false,
            autoplayHoverPause: true, 
            // dragEndSpeed: 1500,
            navSpeed: 800,
            smartSpeed: 800,
            slideTransition: 'linear',
            nav : false,
            animateIn: 'fadeIn',
            animateOut: 'fadeOut',
            navText: ['<svg width="12" height="25" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tkdh__slidr_nav_left_arrow"></use></svg>', '<svg width="12" height="25" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tkdh__slidr_nav_rght_arrow"></use></svg>'],
            lazyLoad: true,
            responsive: {
                768: {
                    items: 1,
                },
                1600: {
                    items: 1,
                }
            }
        });
        
        
        // custom nav buttons with the counter
        $('.comp__fwslidr_wcountr_item_nav_rght a').click(function(){
            // console.log("next");
            fwSlidrwCountr.trigger('next.owl.carousel');
        });
        
        $('.comp__fwslidr_wcountr_item_nav_left a').click(function(){
            // console.log("prev");
            fwSlidrwCountr.trigger('prev.owl.carousel');
        });
        
    }



// ===================================================
// Related Items Slider
// ===================================================

    let relatedItemsBlokSlidr = $(".comp__related_items_blok_sldr");
    if(relatedItemsBlokSlidr.length){
        let argsSliderRelatdBlok = { 
            items: 1,
            loop: false, 
            margin: 30,
            autoplay: true,
            dots: false,
            autoplayHoverPause: true,
            // dragEndSpeed: 1500,
            navSpeed: 1500,
            smartSpeed: 500,
            nav : false,
            animateIn: 'fadeIn',
            animateOut: 'fadeOut',
            // navText: ['<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-left"></use></svg>', '<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-right"></use></svg>'],
            lazyLoad: true,
            responsive: {
                768: {
                    items: 2,
                },
                1200: {
                    items: 3,
                },
                1450: {
                    margin: 60,
                    items: 3,
                }
            }
        }
        relatedItemsBlokSlidr.owlCarousel(argsSliderRelatdBlok);
    }



// ===================================================
// Exclusive Offers Just for You Slider
// ===================================================

    let innerpgOffrsSlidr = $(".tdkh__pg_offerslistinr_relatedslidr_blok");
    if( innerpgOffrsSlidr.length ){
                    
        innerpgOffrsSlidr.on("initialized.owl.carousel changed.owl.carousel", function(e) {
            // console.log(e.item.count);
            if (!e.namespace) {
                return;
            }
            
            let expCounterYMAL, curItemCounterYMAL, totalItemCounterYMAL;
            
            // -- Add trailing zeroes to both CurrentItemCount and TotalCount when the total count is less than 10
            if( e.item.count < 9 ){
                expCounterYMAL = (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+(e.item.count)+"</span>"
            }
            // -- When total count is more than 10
            else{
                // -- if CurrentItemCount is less than 10, add leading zero
                if(e.item.index < 9 ){
                    curItemCounterYMAL = (e.relatedTarget.relative(e.item.index) + 1);
                    // totalItemCounterYMAL = "<span>"+ "0" + (e.item.count) +"</span>";
                    totalItemCounterYMAL = "<span>"+ e.item.count +"</span>"
                }
                else{
                    curItemCounterYMAL = e.relatedTarget.relative(e.item.index) + 1; 
                    totalItemCounterYMAL = "<span>"+ e.item.count +"</span>"
                }
                expCounterYMAL = curItemCounterYMAL + " | " + totalItemCounterYMAL
            }
            
            // -- When TotalCount is exactly 10, 
            if( e.item.count === 10 ){
                
                if(e.item.index === 9 ){
                    expCounterYMAL = e.relatedTarget.relative(e.item.index) + 1 + " | " + "<span>"+ e.item.count +"</span>"
                }
                else{
                    expCounterYMAL = (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+ e.item.count +"</span>"
                }
            }
            
            // -- If TotalCount is exactly 9,
            if( e.item.count === 9 ){
                expCounterYMAL = (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+ (e.item.count) +"</span>"
            }
            
            // Add counter to the HTML
            $(".explore-counter-pgin-offers-slidr").html( expCounterYMAL );
            
        })
        
        .owlCarousel({
            items: 1,
            loop: true, 
            margin: 20,
            autoplay: false,
            dots: false,
            autoplayHoverPause: true, 
            // dragEndSpeed: 1500,
            navSpeed: 800,
            smartSpeed: 800,
            slideTransition: 'linear',
            nav : false,
            animateIn: 'fadeIn',
            animateOut: 'fadeOut',
            navText: ['<svg width="12" height="25" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tkdh__slidr_nav_left_arrow"></use></svg>', '<svg width="12" height="25" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tkdh__slidr_nav_rght_arrow"></use></svg>'],
            lazyLoad: true,
            responsive: {
                768: {
                    items: 2,
                },
                1200: {
                    items: 3,
                }
            }
        });
        
        
        // custom nav buttons with the counter
        $('.tdkh__pg_dinelist_revgrid_nav_rght a').click(function(){
            // console.log("next");
            innerpgOffrsSlidr.trigger('next.owl.carousel');
        });
        
        $('.tdkh__pg_dinelist_revgrid_nav_left a').click(function(){
            // console.log("prev");
            innerpgOffrsSlidr.trigger('prev.owl.carousel');
        });
        
    }

// =================================
// AOS Init
// =================================

    AOS.init();


// =================================
// Fancybox Init
// =================================

    Fancybox.bind("[data-fancybox]", {
        // Thumbs: false,
        Thumbs: {
            type: "modern",
            showOnStart: false,
          },
    });
    
    
    
// =================================
// Header Notice Close
// =================================
    let headerNoticeWrapper  = $(".tdkh__header_notice");
    let headerNoticeCloseBtn = $(".tdkh__header_notice .tdkh__header_notice_btn a");

    if( headerNoticeWrapper.length ){
        headerNoticeCloseBtn.click(function(eHeaderCloseBtn){
            // console.log("clicked");
            headerNoticeWrapper.addClass("closed");
        });
    }



// =================================
// Header Hamburg Menu Button
// =================================

    let hamburgMenuBtn  = $(".tdkh__header_main_hmburg a");
    let hamburgMenuWrap = $("#tdkh__header_main_hmburg_navburg");

    hamburgMenuBtn.click(function(){
        hamburgMenuWrap.toggleClass("opened");
        $("html").addClass("offcanvas_open");
    });


// =================================
// Offcanvas Menu
// =================================

    // offcanvas close
    let offcanvasCloseBtn = $(".tdkh__header_main_offcanvas_header_close a");

    offcanvasCloseBtn.click(function(){
        hamburgMenuWrap.removeClass("opened");
        $("html").removeClass("offcanvas_open");
    });


    // Offcanvas menu submenu arrows
    let offCanvasSubmenu = $("#tdkh__header_main_offcanvas_menu");

    if(offCanvasSubmenu.length){
        // Add span and down arrow to submenu item
        offCanvasSubmenu.find("li.nav-item.menu-item-has-children > a").prepend("<span></span>");
    
        // open submenu on down arrow click
        if(offCanvasSubmenu.length){
            offCanvasSubmenu.find("li.menu-item-has-children a span").click(function(eff){
                eff.preventDefault();
                // console.log("submenu");
                // for self 
                $(this).toggleClass("opened");
                // for sub menu
                $(this).parent().parent().find("ul.sub-menu").toggleClass("opened");
            });
        }
    }

// =================================
// Fixed Menu
// =================================

    $(window).scroll(function (event) {
        let scrollPos = $(window).scrollTop();
        let mainHeader = $(".tdkh__header_main");

        // console.log(scrollPos);
        if(scrollPos  > 20) { 
            mainHeader.addClass("tdkh__header_main_fixed");
        }
        if(scrollPos  < 20) { 
            mainHeader.removeClass("tdkh__header_main_fixed");
            // $(".ck_pg_menu .ck_pg_menu_items").removeClass("ck_pg_menu_items-fixed");
        }
    });


// =======================================
// Booking Widget
// =======================================

    // ------------------------
    // Toggle 
    // ------------------------

    let mainBookBtn      = $("#tdkh__header_main_menu_ibe_bookbtn");
    let btmFootrBookBtn  = $(".tdkh__header_btmbar_item_bookbtn a");
    let ibeWidget        = $(".tdkh__header_main_menu_ibe_bookwdgt");
    let ibeWidgetInClose = $(".tdkh__header_main_menu_ibe_bookwdgt .tdkh_ibe_bookwdgt_close");

    let ibeWidgetOpenedOverlay = $(".ibeWidget__opened_overlay");

    mainBookBtn.click(function(emainBookBtn){
        ibeWidget.toggleClass("opened"); 
    });

    btmFootrBookBtn.click(function(emainBookBtn){
        ibeWidget.toggleClass("opened");
        $("html").addClass("ibeWidget__opened");
        // $("body").prepend("<div class='ibeWidget__opened_overlay'></div>")
    });
    
    ibeWidgetInClose.click(function(bwClose){
        ibeWidget.removeClass("opened");
        $("html").removeClass("ibeWidget__opened");
        // ibeWidgetOpenedOverlay.remove();
    });

    


    // ------------------------
    // Book Widget Inners
    // ----------------------

    const picker = new easepick.create({
        element: "#ibe_datepickr",
        css: [
            "https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css",
            theme_url_in_js + 'assets/easepick_custom.css',
        ],
        zIndex: 10,
        date : new Date(),
        calendars :1,
        RangePlugin: {
            tooltipNumber(num) {
                return num - 1;
            },
            locale: {
                one: "night",
                other: "nights"
            },
            delimiter : "/",
        },
        LockPlugin: {
            minDate: new Date(),
            selectBackward: false,
            inseparable: true,

            minDays: 2,
            selectForward: true,
            selectBackward : false,
        },
        plugins: [
            "RangePlugin",
            "LockPlugin"
        ],

        setup(picker) {

            const DateTime = easepick.DateTime;
            const lockPlugin = picker.PluginManager.getInstance('LockPlugin');

            picker.on('preselect', (e) => {
                let { start, end } = e.detail;
                
                let a = new DateTime(); 
                let b = new DateTime();
                
                if (start && start.isBetween(a, b, '[]')) {
                    lockPlugin.options.minDays = 2;
                }
                
                // refresh layout
                picker.renderAll();
            });

            picker.on('select', (e) => {
                const { view, date, target } = e.detail;

                // Get CHECKIN DATE DATA

                let startDate = e.detail.start;
                
                var startDate_year = startDate.format('YYYY');
                var startDate_mnth = startDate.format('MMMM');
                var startDate_date = startDate.format('DD');
                var startDate_dayy = startDate.toLocaleString('en-us', {weekday:'long'});

                // Set checkin Date in Widget _______________________________
                $(".tdkh_ibe_bookwdgt_dates_item_chkin .tdkh_ibe_bookwdgt_dates_item_disp_day").html(startDate_date);

                $(".tdkh_ibe_bookwdgt_dates_item_chkin .ibe_checkin_mnth").html(startDate_mnth);
                $(".tdkh_ibe_bookwdgt_dates_item_chkin .ibe_checkin_year").html(startDate_year);
                $(".tdkh_ibe_bookwdgt_dates_item_chkin .tdkh_ibe_bookwdgt_dates_item_disp_date").html(startDate_dayy);


                // To hidden input , to pass for the IBE

                $("#ibe_checkin").val(startDate_year + "-" + startDate.format('MM') + "-" + startDate_date);
            


                // Get CHECKOUT DATE DATA
                let endDate = e.detail.end;

                var endDate_year = endDate.format('YYYY');
                var endDate_mnth = endDate.format('MMMM');
                var endDate_date = endDate.format('DD');
                var endDate_dayy = endDate.toLocaleString('en-us', {weekday:'long'});


                // Set checkout Date in Widget _______________________________
                $(".tdkh_ibe_bookwdgt_dates_item_chkout .tdkh_ibe_bookwdgt_dates_item_disp_day").html(endDate_date);

                $(".tdkh_ibe_bookwdgt_dates_item_chkout .ibe_checkout_mnth").html(endDate_mnth);
                $(".tdkh_ibe_bookwdgt_dates_item_chkout .ibe_checkout_year").html(endDate_year);
                $(".tdkh_ibe_bookwdgt_dates_item_chkout .tdkh_ibe_bookwdgt_dates_item_disp_date").html(endDate_dayy);

                // To hidden input , to pass for the IBE

                $("#ibe_checkout").val(endDate_year + "-" + endDate.format('MM') + "-" + endDate_date);


                // console.log(startDate.format('DD MMMM YYYY'));
                // console.log( startDate.toLocaleString('en-us', {weekday:'long'}) );
            });
        },
    }); // picker


    // ---------------------------------------------------------
    // Set selected values on load
    
    let getSelectedDatesFrom = $("#ibe_datepickr").val();
    
    if( getSelectedDatesFrom || getSelectedDatesFrom != "" ){
        // console.log("IN");
        let getSelectedDates = getSelectedDatesFrom.split("/");
        
        let getSelectedStartDate = getSelectedDates[0];
        let getSelectedEndDate = getSelectedDates[1];
        
        
        getFormattedStartDate   = new Date(getSelectedStartDate);
        getFormattedEndDate     = new Date(getSelectedEndDate);
        // console.log( getFormattedStartDate );
    
        // Set Selected dates for Check In
        $(".tdkh_ibe_bookwdgt_dates_item_chkin .tdkh_ibe_bookwdgt_dates_item_disp_day").html(getFormattedStartDate.getUTCDate() );
        
        $(".tdkh_ibe_bookwdgt_dates_item_chkin .ibe_checkin_mnth").html( getFormattedStartDate.toLocaleString('default', { month: 'long' }) );
        $(".tdkh_ibe_bookwdgt_dates_item_chkin .ibe_checkin_year").html( getFormattedStartDate.getUTCFullYear() );
        $(".tdkh_ibe_bookwdgt_dates_item_chkin .tdkh_ibe_bookwdgt_dates_item_disp_date").html( getFormattedStartDate.toLocaleString('en-us', {weekday:'long'}) );
    
    
        // Set Selected dates for Check Out
        $(".tdkh_ibe_bookwdgt_dates_item_chkout .tdkh_ibe_bookwdgt_dates_item_disp_day").html(getFormattedEndDate.getUTCDate());
        
        $(".tdkh_ibe_bookwdgt_dates_item_chkout .ibe_checkout_mnth").html( getFormattedEndDate.toLocaleString('default', { month: 'long' }) );
        $(".tdkh_ibe_bookwdgt_dates_item_chkout .ibe_checkout_year").html( getFormattedEndDate.getUTCFullYear() );
        $(".tdkh_ibe_bookwdgt_dates_item_chkout .tdkh_ibe_bookwdgt_dates_item_disp_date").html( getFormattedEndDate.toLocaleString('en-us', {weekday:'long'}) );

    }

    else{
        // console.log("Else");
        let getCurrentDate   = new Date();

        let getTomorrow  = new Date();
        let getTomorrowDate  = new Date(getTomorrow);
        getTomorrowDate.setDate(getTomorrow.getDate() + 1);


        // console.log( getCurrentDate );
        // console.log( getTomorrowDate );
    
        // Set Today's dates for Check In
        $(".tdkh_ibe_bookwdgt_dates_item_chkin .tdkh_ibe_bookwdgt_dates_item_disp_day").html(getCurrentDate.getUTCDate() );
        
        $(".tdkh_ibe_bookwdgt_dates_item_chkin .ibe_checkin_mnth").html( getCurrentDate.toLocaleString('default', { month: 'long' }) );
        $(".tdkh_ibe_bookwdgt_dates_item_chkin .ibe_checkin_year").html( getCurrentDate.getUTCFullYear() );
        $(".tdkh_ibe_bookwdgt_dates_item_chkin .tdkh_ibe_bookwdgt_dates_item_disp_date").html( getCurrentDate.toLocaleString('en-us', {weekday:'long'}) );

        // Set Tomorrow's dates for Check Out
        $(".tdkh_ibe_bookwdgt_dates_item_chkout .tdkh_ibe_bookwdgt_dates_item_disp_day").html(getTomorrowDate.getUTCDate());
        
        $(".tdkh_ibe_bookwdgt_dates_item_chkout .ibe_checkout_mnth").html( getTomorrowDate.toLocaleString('default', { month: 'long' }) );
        $(".tdkh_ibe_bookwdgt_dates_item_chkout .ibe_checkout_year").html( getTomorrowDate.getUTCFullYear() );
        $(".tdkh_ibe_bookwdgt_dates_item_chkout .tdkh_ibe_bookwdgt_dates_item_disp_date").html( getTomorrowDate.toLocaleString('en-us', {weekday:'long'}) );
    }



    // Show datepicker calender on dateblock click
    let checkInBlok = $(".tdkh_ibe_bookwdgt_dates_item_disp");
    checkInBlok.click(function(){
        $("#ibe_datepickr").click();
    });






    // Book widget counter inputs
    function leadingZeros(input) {
        if(!isNaN(input.value) && input.value.length === 1) {
            input.value = '0' + input.value;
        }
    }

    // ========================================================
    // Counters buttons
    // ========================================================
    
    let countBtnWrapper     = $(".tdkh_ibe_bookwdgt_countinputs_item_input");
    
    // Rooms
    let inputValsRooms      = countBtnWrapper.find("#ibe_rooms");
    
    inputValsRooms.parent().find("button.plus").click(function(eCBtn){
        let currentRmValue = inputValsRooms.val();
        if(currentRmValue < 9){
            let newVals = ++currentRmValue;
            inputValsRooms.val( "0" + (newVals) );
        }
        else{
            inputValsRooms.val( "10" );
        }
    });
    inputValsRooms.parent().find("button.minus").click(function(eCBtn){
        let currentRmValue = inputValsRooms.val();
        if(currentRmValue > 1){
            let newVals = --currentRmValue;
            inputValsRooms.val( "0" + (newVals) );
        }
        else{
            inputValsRooms.val( "01" );
        }
    });


    // Adults
    let inputValsAdults     = countBtnWrapper.find("#ibe_adults");

    inputValsAdults.parent().find("button.plus").click(function(eCBtn){
        let currentRmValue = inputValsAdults.val();
        if(currentRmValue < 9){
            let newVals = ++currentRmValue;
            inputValsAdults.val( "0" + (newVals) );
        }
        else{
            inputValsAdults.val( "10" );
        }
    });

    inputValsAdults.parent().find("button.minus").click(function(eCBtn){
        let currentRmValue = inputValsAdults.val();
        if(currentRmValue > 1){
            let newVals = --currentRmValue;
            inputValsAdults.val( "0" + (newVals) );
        }
        else{
            inputValsAdults.val( "01" );
        }
    });


    // Children
    let inputValsChildrn    = countBtnWrapper.find("#ibe_children");

    inputValsChildrn.parent().find("button.plus").click(function(eCBtn){
        let currentRmValue = inputValsChildrn.val();
        if(currentRmValue < 9){
            let newVals = ++currentRmValue;
            inputValsChildrn.val( "0" + (newVals) );
        }
        else{
            inputValsChildrn.val( "10" );
        }
    });

    inputValsChildrn.parent().find("button.minus").click(function(eCBtn){
        let currentRmValue = inputValsChildrn.val();
        if(currentRmValue > 1){
            let newVals = --currentRmValue;
            inputValsChildrn.val( "0" + (newVals) );
        }
        else{
            inputValsChildrn.val( "00" );
        }
    });
    

// ========================================================
// Contact Us form layout
// ========================================================

    let contactPageForm = $(".tdkh__pg_contact_form_data form.dfb-form");

    if(contactPageForm.length){
        
        $('#enq_type_id_wrap').after('<div id="tdkh__pg_contact_form_data_tworow"><div id="tdkh__pg_contact_form_data_tworow_left"></div><div id="tdkh__pg_contact_form_data_tworow_right"></div></div>');

        if( $(window).width() > 768 ){
            contactPageFieldsDynamicUpdates();
        }

        $(window).on("resize", function (){
            if( $(window).width() > 768 ){
                contactPageFieldsDynamicUpdates();
            }
            else{
                reversecontactPageFieldsDynamicUpdates();
            }
        });
        
    }

    function contactPageFieldsDynamicUpdates(){

        $("#enq_phone_id_wrap").appendTo("#tdkh__pg_contact_form_data_tworow_left");
        $("#enq_email_id_wrap").appendTo("#tdkh__pg_contact_form_data_tworow_left");
        $("#enq_subj_id_wrap").appendTo("#tdkh__pg_contact_form_data_tworow_left");
        
        $("#enq_message_id_wrap").appendTo("#tdkh__pg_contact_form_data_tworow_right");
    }

    function reversecontactPageFieldsDynamicUpdates(){
        $("#enq_phone_id_wrap").insertAfter("#enq_type_id_wrap");
        $("#enq_email_id_wrap").insertAfter("#enq_phone_id_wrap");
        $("#enq_subj_id_wrap").insertAfter("#enq_email_id_wrap");
        
        $("#enq_message_id_wrap").insertAfter("#enq_subj_id_wrap");
    }



// ========================================================
// Form Builder formsdata :: Custom Checkboxes
// ========================================================
    var fb_forms_chkboxes = $("form.dfb-form .dfb-form-group .response-field-checkboxes .checkbox-inline");

    if(fb_forms_chkboxes){
        fb_forms_chkboxes.append('<span class="fb_forms_custom_chkbox"></span>');

        fb_forms_chkboxes.find("input:checkbox").change(function(){
            if($(this).is(":checked")) {
                $('.fb_forms_custom_chkbox').addClass("checked");
            } else {
                $('.fb_forms_custom_chkbox').removeClass("checked");
            }
        });
    }



// ========================================================
// Hamburg icon and Header Notice visibility
// ========================================================

let mainHamburgIcon = $(".tdkh__header_main_hmburg .tdkh__header_main_hmburg_icon");
let mainHeaderNotice = $(".tdkh__header_notice");
let inrPgNobanrWrapr = $("main.main__inrpg_nobanr");

// move hamburg icon when notice is closed
mainHeaderNotice.find(".tdkh__header_notice_btn a").click(function(){
    mainHamburgIcon.addClass("tdkh_headrnotice_remvd");
    inrPgNobanrWrapr.addClass("notice__closed");
});

// see if notice is visible 
if( !(mainHeaderNotice.is(":visible")) ){
    mainHamburgIcon.addClass("tdkh_headrnotice_remvd");
    inrPgNobanrWrapr.addClass("notice__closed");
}

// is notice element is not in the dom
if( !(mainHeaderNotice.length) ){
    mainHamburgIcon.addClass("tdkh_headrnotice_remvd");
    inrPgNobanrWrapr.addClass("notice__closed");
}

// when notice is closed with the notice having the class
if( mainHeaderNotice.hasClass(".closed") ){
    mainHamburgIcon.addClass("tdkh_headrnotice_remvd");
    inrPgNobanrWrapr.addClass("notice__closed");
}




// ========================================================
// News Articles listing loadmore
// ========================================================
    let newsArticlesLoadMore    = $("#news_listing_loadmore");
    let currentPageStatus       = 1;
    let offsetPageStatus        = 1;

    let articlesWrapper         = $("#tdkh__pg_newslist_grid_cont");
    let currentLoadedCounter    = articlesWrapper.children().length;
    let currentCounterElem      = $("#count_current");

    if(newsArticlesLoadMore.length){
        
        newsArticlesLoadMore.click(function(eloadmor){
    
            eloadmor.preventDefault();
            // hide the button until the data loads
            $(this).fadeOut(400);
    
            // page count
            currentPageStatus++;
    
            // show da loader
            $("#asyncloader").fadeIn(600);
    
            data = {
                action: 'article_listing_load_more',
                paged: currentPageStatus,
                offset: offsetPageStatus * 6, // initial loaded items skipping to load.
            };
            
            // page count
            // currentPageStatus++;
            offsetPageStatus++;
    
            $.post(ajaxurl, data, function(response) {
                if (response) {
                    
                        // // Create a jQuery object from the response HTML
                        // let responseAsJQobject = $(response);
                        // console.log(responseAsJQobject);
                        // // Filter out text nodes and consider only elements with the class "comp__grid_1233_item"
                        // var $gridItems = responseAsJQobject.filter('.comp__grid_1233_item');
                        // // Get the length of the jQuery collection, which represents the number of matching elements
                        // var itemCount = $gridItems.length;
    
                    // One lining all above
                    // currentCounterElem.html( currentLoadedCounter + $(response).filter('.comp__grid_1233_item').length );
    
                    $("#asyncloader").fadeOut(1600);
                    setTimeout( function() {
                        $('#tdkh__pg_newslist_grid_cont').append(response).delay(800); 
                        $("#news_listing_loadmore").fadeIn(500);
                    }, 1600);
                    
                } else {
                    $("#news_listing_loadmore").hide(500);
                    $("#asyncloader").fadeOut(800);

                    setTimeout( function() {
                        $('#tdkh__pg_newslist_grid_cont').append("<p class='w100 eqvb__txt_subhead show_center' id='load_more_ended'>You're all caught up...</p>");
                    }, 1000);
                }
            });
    
            
        });

    }




}); //  end document ready



// =================================================
// 91. Owl Slider Trigers 
// =================================================
// Fix owl stagePadding issue
    $( window ).on("load", function() {
        $('.owl-carousel').trigger('refresh.owl.carousel');
    });
    $(window).on("resize", function () {
        $('.owl-carousel').trigger('refresh.owl.carousel');
    });
    $(document).ready(function() {
        $('.owl-carousel').trigger('refresh.owl.carousel');
    });

// =================================================
// 92. Scroll to Top
// =================================================
    $(document).ready(function() {

        let scrollTopBtn = $(".scroll_to_top")
        
        // Scroll on click
        scrollTopBtn.click(function() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });

        // Visibility on scroll position
        $(window).scroll(function (event) {
            let scrollPos = $(window).scrollTop();

            if(scrollPos  > 400) { 
                scrollTopBtn.addClass("show"); 
            }
            if(scrollPos  < 400) {
                scrollTopBtn.removeClass("show");
            }

        });
    });


// =================================================
// 92.1 Page Scroll to Top on page refresh
// =================================================

    // Prevent automatic page location restoration (browsers "remember" the last scroll position before unloading)
    history.scrollRestoration = "manual";

    $(window).on('afterload', function() {
        $(window).scrollTop(0);
    });



// =================================================
// 93. Images loading animation / placeholder
// =================================================
    $( window ).on("load", function() {
        // $('img').removeClass('img_loading');
        setTimeout(function(){
            $('img').removeClass('img_loading');
        }, 500);
    });



// =================================================
// 94. Window dimensions
// =================================================

// DEV Tools - Remove these on live/preview

    // $(document).ready(function(){
    //     var MEASUREMENTS_ID = 'measurements'; // abstracted-out for convenience in renaming
    //     $("body").append('<div id="'+MEASUREMENTS_ID+'"></div>');
    //     $("#"+MEASUREMENTS_ID).css({
    //         'position': 'fixed',
    //         'top': '60px',
    //         'right': '0',
    //         'background-color': '#eaee59',
    //         'color': '#000',
    //         'padding': '10px 30px',
    //         'font-size': '12px',
    //         'opacity': '1',
    //         'z-index' : '99999',
    //         'font-weight' : '600',
    //         'font-family' : 'consolas'
    //     });
    //     getDimensions = function(){
    //         // return $(window).width() + ' (' + $(document).width() + ') x ' + $(window).height() + ' (' + $(document).height() + ')';
    //         return $(window).width() + 'px' + '  x ' + $(window).height() + 'px';
    //     }
    //     $("#"+MEASUREMENTS_ID).text(getDimensions());
    //     $(window).on("resize", function(){
    //         $("#"+MEASUREMENTS_ID).text(getDimensions());
    //     });
    
    // });




// datepicker
$(document).ready(function(){

    

    
    



    // var endDate = $('#ibe_checkout').data('daterangepicker').endDate._d;

    // $("#lolz").html(startDate);
    
    
});